var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.396 19.88a1.574 1.574 0 0 0 1.208 0 1.58 1.58 0 0 0 .513-.342l8.42-8.421a1.579 1.579 0 1 0-2.232-2.233l-5.726 5.725V1.58a1.579 1.579 0 1 0-3.158 0v13.03L2.695 8.884a1.579 1.579 0 1 0-2.233 2.232l8.42 8.42m.514.344a1.575 1.575 0 0 1-.51-.34Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.23c103eb223cc7b6aee580e0e5d394ea.svg";